// extracted by mini-css-extract-plugin
module.exports = {"icon":"clock-icon_icon__2tFd6"};